import { render, staticRenderFns } from "./BeneficiarioCodigo.vue?vue&type=template&id=2a8c02f2"
import script from "./BeneficiarioCodigo.vue?vue&type=script&lang=js"
export * from "./BeneficiarioCodigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports